import projectLocationTypeEnum from "src/enum/projectLocationTypeEnum";
import myProjectStatusEnum from "src/enum/myProjectStatusEnum";
import { apiDateTimeStringToDate } from "src/api/apiDateTimeHandler";
var getMyProjectStatus = function (project, appointment, projectEligibility) {
    switch (project.locationType) {
        case projectLocationTypeEnum.ONLINE:
        case projectLocationTypeEnum.AT_HOME:
            return getMyOnlineProjectStatus(project);
        case projectLocationTypeEnum.PHYSICAL:
            return getMyPhysicalProjectStatus(project, appointment, projectEligibility);
        default:
            throw new Error("Unexpected case: ".concat(project.locationType));
    }
};
var getMyOnlineProjectStatus = function (project) {
    if (project.locationType !== projectLocationTypeEnum.ONLINE && project.locationType !== projectLocationTypeEnum.AT_HOME) {
        throw new Error('Project is not an online or at home project.');
    }
    if (project.questionnaireLink) {
        return myProjectStatusEnum.ONLINE_PROJECT_CAN_FILL_IN_QUESTIONNAIRE;
    }
    return myProjectStatusEnum.ONLINE_PROJECT_CANNOT_FILL_IN_QUESTIONNAIRE;
};
var getMyPhysicalProjectStatus = function (project, appointment, projectEligibility) {
    if (project.locationType !== projectLocationTypeEnum.PHYSICAL) {
        throw new Error('Project is not a physical project.');
    }
    if (appointment && appointment.projectInstance && new Date() > apiDateTimeStringToDate(appointment.projectInstance.start)) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_ALREADY_PARTICIPATED;
    }
    if (appointment && appointment.cancellable) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_HAS_MADE_APPOINTMENT_AND_CAN_CANCEL;
    }
    if (appointment) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_HAS_MADE_APPOINTMENT_AND_CANNOT_CANCEL;
    }
    if (projectEligibility && projectEligibility.eligible && project.remainingNumberOfAppointments === 0) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_MAY_MAKE_APPOINTMENT_BUT_NO_SPOTS_LEFT;
    }
    if (projectEligibility && projectEligibility.eligible) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_MAY_MAKE_APPOINTMENT;
    }
    if (projectEligibility && !projectEligibility.eligible) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_ENTRY_QUESTIONNAIRE_IS_REJECTED;
    }
    if (!project.entryQuestionnaireLink && !projectEligibility) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_CAN_FILL_IN_ENTRY_QUESTIONNAIRE_BUT_NO_SPOTS_LEFT;
    }
    if (project.entryQuestionnaireLink) {
        return myProjectStatusEnum.PHYSICAL_PROJECT_CAN_FILL_IN_ENTRY_QUESTIONNAIRE;
    }
    throw new Error('Unexpected case');
};
export default {
    getMyProjectStatus: getMyProjectStatus
};
